export const Q_VALUE_REPORT_RECORD_TYPES = {
    CAR: 'corrective_action_report',
    EIGHT_D: 'eight_d_report',
};

/** Persisted closed report (saved / submitted) — not merely selecting Closed in the dropdown. */
export function isQValueReportReadOnly(state) {
    return !!(state && state.isClosedLocked);
}

export function canSaveQValueReportDraft(state) {
    if (!state || isQValueReportReadOnly(state)) return false;
    if (String(state.status || '').trim() === 'Closed') return false;
    return true;
}

export function shouldShowSubmitForApproval(state) {
    if (!state || !state.id || isQValueReportReadOnly(state)) return false;
    return String(state.status || '').trim() === 'Closed';
}

export function approvalStatusStyle(label) {
    if (label === 'Approved') return { color: '#218838', fontWeight: 700 };
    if (label === 'Rejected') return { color: '#dc3545', fontWeight: 700 };
    if (label === 'Pending Approval') return { color: '#c77800', fontWeight: 700 };
    return { color: '#6c757d', fontWeight: 600 };
}
